var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 29C30 30.1046 29.1046 31 28 31L12 31C10.8954 31 10 30.1046 10 29V24C10 23.4477 10.4477 23 11 23C11.5523 23 12 23.4477 12 24V29L28 29V24C28 23.4477 28.4477 23 29 23C29.5523 23 30 23.4477 30 24V29Z",
    fill: "#5F6161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7071 25.2071C20.3166 25.5976 19.6835 25.5976 19.2929 25.2071L14.5 20.4142C14.1095 20.0237 14.1095 19.3905 14.5 19C14.8906 18.6095 15.5237 18.6095 15.9142 19L19 22.0858V10C19 9.44772 19.4478 9 20 9C20.5523 9 21 9.44772 21 10V22.0858L24.0858 19C24.4763 18.6095 25.1095 18.6095 25.5 19C25.8905 19.3905 25.8905 20.0237 25.5 20.4142L20.7071 25.2071Z",
    fill: "#5F6161"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadGrey);
export default __webpack_public_path__ + "static/media/DownloadGrey.2b4e3c35e4a7f538fbe7bc9c395ad1bf.svg";
export { ForwardRef as ReactComponent };